<script lang="ts" setup>
import ActionCharts from '@/components/statistics/ActionCharts.vue';
import Co2ScanCharts from '@/components/statistics/Co2ScanCharts.vue';
import QuizCharts from '@/components/statistics/QuizCharts.vue';
import StatisticsMenu from '@/components/statistics/StatisticsMenu.vue';
import UserCharts from '@/components/statistics/UserCharts.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <StatisticsMenu item="Quiz of the day" />
  <v-container>
    <QuizCharts v-if="route.params.slug === 'quizzes'" />
    <ActionCharts v-if="route.params.slug === 'actions'" />
    <Co2ScanCharts v-if="route.params.slug === 'co2-scan'" />
    <UserCharts v-if="route.params.slug === 'user-interests'" />
  </v-container>
</template>
